import React from "react";
import { FrontPageType } from "../../types/optimizely/frontpage";
import { HeroContainer } from "../../components/HeroContainer/HeroContainer";
import { ContentArea } from "../../components/ContentArea/ContentArea";
import { ServicesBlockWrapper } from "../../components/ServicesBlockWrapper/ServicesBlockWrapper";

interface FrontPageProps {
  content: FrontPageType;
}

export const FrontPage: React.FC<FrontPageProps> = ({ content }) => {
  if (!content) {
    return <></>;
  }

  return (
    <>
      {/* Smelly fix
      Client wanted to uniform the whitespace on frontpage and other pages
      There are breadcrumbs on other pages, but not on front page  */}
      <div className="md:min-h-0 lg:min-h-[34px]" />
      <HeroContainer content={content} />
      <ServicesBlockWrapper currentPageId={content.contentLink.id} />
      <ContentArea contentArea={content.mainContentArea} isFrontPage={true}/>
    </>
  );
};
